import { computed } from 'vue'

import type { GroupsStoreValuesType } from '@/features/groups/stores/groups/groups.store'

export function selectGetSelectedGroupId(state: GroupsStoreValuesType) {
  return computed(() => state.selectedGroupId)
}

export function selectGetTempSelectedGroupId(state: GroupsStoreValuesType) {
  return computed(() => state.tempSelectedGroupId)
}

export function selectGetTempSelectedObjectiveId(state: GroupsStoreValuesType) {
  return computed(() => state.tempSelectedObjectiveId)
}
